import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { maybeRegisterOfflineSW } from './utils/registerOfflineSW';
import { startOfflineAuthSync } from './utils/offlineAuth';
import { startNetMonitor } from './utils/netMonitor';
import { startTouchDragScroll } from './utils/touchDragScroll';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();

// Offline service worker — yalnız "Offline rejim" tikli tenantda (demo), kill-switch ilə
maybeRegisterOfflineSW();
// Offline giriş paketi + günlük lisenziya güzəşti: online ikən 10 dəq.-dən bir yenilənir
startOfflineAuthSync();
// Online ⇄ offline keçidlərini aktiv ping ilə izlə (offline tikli tenantda)
startNetMonitor();

// Rəqəm sahələrində siçan təkəri dəyəri DƏYİŞMƏSİN (16.00 → 15.90 kimi təsadüfi azalma).
// Fokuslu number input üzərində təkər fırladılanda fokusu götür: dəyər qalır, səhifə adi qaydada sürüşür.
document.addEventListener('wheel', (e) => {
  const el = document.activeElement;
  if (el && el.tagName === 'INPUT' && el.type === 'number' && el === e.target) el.blur();
}, { passive: true });

// Sensor ekran: cədvəlləri barmaqla sağa-sola sürüşdür (body touch-action: pan-y bunu bağlayırdı)
startTouchDragScroll();
